<!-- Image -->
<img
  [src]="listing().primaryImage"
  [alt]="listing().address.streetAddress"
  width="336"
  height="144"
  class="w-full h-36 object-cover"
  placeholder
/>

<div class="p-4 flex flex-col gap-0.5 text-sm leading-none my-auto">
  @if (!listing().pending) {
    <p class="font-header text-2xl leading-none text-primary-500 dark:text-white/70 mb-2">
      {{ listing().price | currency: 'USD' : 'symbol' : '1.0-0' }}
    </p>
  }

  <p>VNH#: {{ listing().vls }}</p>

  @if (stateService.community() === 'villages') {
    <p>{{ listing().village.displayTitle }}</p>
  } @else {
    <p>{{ listing().address }}</p>
  }
</div>
